import { ReactNode } from 'react';

import { Placeholder } from 'modules/common/components/Placeholder';
import { useAuth } from 'modules/auth/hooks/useAuth';

export interface LogginInGuardProps {
  children: ReactNode;
  fallback: ReactNode;
}

export const LoggingInGuard = ({ children, fallback }: LogginInGuardProps) => {
  const { authToken, isLoggedIn, isLoggingIn } = useAuth();

  const hasAuthToken = Boolean(authToken);
  const shouldLogIn = hasAuthToken && !isLoggedIn;

  return (
    <Placeholder
      hasPlaceholder={isLoggingIn || shouldLogIn}
      placeholder={fallback}
    >
      {children}
    </Placeholder>
  );
};
